import styled from "styled-components";
import { useState } from "react";
import { HelpText } from "../App.styles";

const Wrapper = styled.div`
  position: relative;
`;

const sanitizeCommaSeparatedValue = (sourceValue = '') => sourceValue
  .split(',')
  .map((entry) => entry.trim())
  .filter(Boolean)
  .join(',');

const Textarea = ({ help, label, labelClassName = '', mode = 'clean', name, useQuery, wrapperClass = '', ...rest }) => {
  const [collection, setCollection] = useQuery();
  const [value, setValue] = useState(collection[name] || '');
  const [focus, setFocus] = useState(false);
  const shouldSanitizeCommaSeparated = ["multiplechoice", "trivia"].includes(name);

  const commit = () => {
    const nextValue = shouldSanitizeCommaSeparated
      ? sanitizeCommaSeparatedValue(value)
      : value;

    setFocus(false);

    if (nextValue !== value) {
      setValue(nextValue);
    }

    if (nextValue !== collection[name]) {
      setCollection({ [name]: nextValue });
    }
  };

  const changes = ({ target }) => {
    if (name === "multiplechoice") {
      const choices = target.value.split(",");

      if (choices.length > 5) {
        let str = target.value.slice(0, -1);
        setValue(str);
      } else {
        setValue(target.value);
      }
    } else {
      setValue(target.value);
    }
  };

  return (
    <Wrapper className={`form-${mode} ${wrapperClass}`}>
      <textarea
        className="form-control active"
        rows={5}
        value={value}
        onChange={changes}
        onBlur={commit}
        onFocus={() => setFocus(true)}
        {...rest}
      />
      <label className={`form-label ${labelClassName}`}>{label}</label>
      {help && <HelpText focus={focus}>{help}</HelpText>}
    </Wrapper>
  );
};

export default Textarea;
